module.exports = __webpack_public_path__ + "static/media/close.802d9fa7.svg";